<template>
  <v-sheet>
    <h2>Sendgrid events</h2>
    <v-data-table
      :headers="headers"
      :items="emailEvents"
      :items-per-page="5"
      dense
      :loading="loading"
      class="mt-2 elevation-2"
    ></v-data-table>
  </v-sheet>
</template>

<script>
import { EMAIL_COMMUNICATIONS } from "../../../../constants/graphql/client/activity"
import { YYYYMMDD_readable } from "@/lib/fancy_date";

export default {
  name: "ClientEmailActivity",
  props: ["userId"],
  data() { 
    return {
      loading: true,
      emailEvents: [],
      user: {},
      headers: [
        {
          text: 'Email Name',
          value: 'sgTemplateName',
        },
        { text: 'Status', value: 'event' },
        { text: 'Date', value: 'timestamp' },
      ]
    }
  },
  methods: {
    formatDate(date) {
      return YYYYMMDD_readable(date);
    },
  },
  apollo: {
    user: {
      query: EMAIL_COMMUNICATIONS,
      variables() {
        let encoded_json_payload =btoa("UserNode:" + this.userId);

        return {
          userId: encoded_json_payload
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.loading = false;
          this.emailEvents = response.data.user.userEmailCommunications.map((item) => {
            return {
              sgTemplateName: item.sgTemplateName == null ? 'Passsword Reset' : item.sgTemplateName,
              event: item.event,
              timestamp: this.formatDate(item.timestamp),
            }
          });
        }
      }
    }
  }
}
</script>